import type { FormControl } from '@angular/forms';
import { type ValidationErrors, type ValidatorFn } from '@angular/forms';

export const bothOrNoneRequiredErrorKey = 'bothOrNoneRequired';

export function bothOrNoneRequired<T>(
  field1: FormControl<T>,
  field2: FormControl<T>,
  emptyChecker: (value: T) => boolean,
): ValidatorFn {
  return (): ValidationErrors | null => {
    const field1Value = field1?.value;
    const field2Value = field2?.value;

    const filled1 = field1Value !== null && emptyChecker(field1Value);
    const filled2 = field2Value !== null && emptyChecker(field2Value);

    // Mindkettő kitöltött vagy egyik sem – OK
    if ((filled1 && filled2) || (!filled1 && !filled2)) {
      if (field1.hasError(bothOrNoneRequiredErrorKey)) {
        field1.setErrors(null);
      }
      if (field2.hasError(bothOrNoneRequiredErrorKey)) {
        field2.setErrors(null);
      }

      return null;
    }

    // Egy van kitöltve – hiba mindkét mezőn
    const error = { [bothOrNoneRequiredErrorKey]: true };
    if (!filled1) {
      field1.markAsTouched();
      field1.setErrors(error);
    }
    if (!filled2) {
      field2.markAsTouched();
      field2.setErrors(error);
    }
    return error;
  };
}
